import React, { Fragment } from 'react';
import { Card } from 'semantic-ui-react';
import { Box } from 'theme-ui';
import { DEACONS_CONTACT, PRICE } from '../lib/constants';

export const Summary = ({ level, isNewbie }) => (
  <Card fluid>
    <Card.Content>
      <Card.Header>Итак:</Card.Header>
    </Card.Content>
    <Card.Content>
      <p>Приготовь песню для вокала.</p>
      <p>Приготовь произведение для дирижирования.</p>
      <p>
        Приготовься к техническому зачёту
        {isNewbie && ' (если тебя определят в группу выше чем 1-б)'}.
      </p>
      {isNewbie && <p>Принеси рекомендательное письмо.</p>}
      <p>Выучи открывок из Библии – 10 стихов.</p>
      <p>Выучи стихотворение.</p>
      {!isNewbie && (
        <p>Принеси сертификат.</p>
      )}
      <p>Принеси/пришли ${PRICE}.</p>
      <p>
        Реши вопрос с ночлегом – реши этот вопрос с дьяконами (заранее, за 3-4 дня до приезда):
        {DEACONS_CONTACT.map(x => (
          <Fragment key={x.linkNum}>
            {' '}{x.name}{' '}
            <Box
              as='a'
              href={`tel:+${x.linkNum}`}
              sx={{ display: 'inline', whiteSpace: 'nowrap' }}
            >
              {x.displayNum}
            </Box>
          </Fragment>
        ))}
        .
      </p>
      <p>
        Зарегистрируйся <a href='#registration'>снизу</a>.
      </p>
    </Card.Content>
  </Card>
);
